import store from "@frameworks/web/redux/store";
import { CHECK_MARGIN_DATA, CHECK_MARGIN_ERROR_DATA, CHECK_MARGIN_HIDE_ERROR_DATA, CHECK_MARGIN_START_LOADER, CHECK_MARGIN_STOP_LOADER, REMOVE_MARGIN_DATA, } from "../interface/ICheckMargin";
class CheckMarginActions {
    constructor() {
        this.dispatch = store.dispatch;
    }
    getCheckMargin(checkMargin) {
        this.dispatch({
            type: CHECK_MARGIN_DATA,
            payload: { checkMargin },
        });
    }
    removeMarginData() {
        this.dispatch({
            type: REMOVE_MARGIN_DATA,
        });
    }
    setError(payload, errorType) {
        this.dispatch({
            type: CHECK_MARGIN_ERROR_DATA,
            payload: { errorData: payload },
        });
    }
    hideError(errorType) {
        this.dispatch({
            type: CHECK_MARGIN_HIDE_ERROR_DATA,
        });
    }
    loader() {
        this.dispatch({
            type: CHECK_MARGIN_START_LOADER,
        });
    }
    stopLoader() {
        this.dispatch({
            type: CHECK_MARGIN_STOP_LOADER,
        });
    }
}
export default CheckMarginActions;
